module.exports = __webpack_public_path__ + "static/media/Tv4Group_Svezia.96bb9561.png";